import { inject, InjectionToken, Provider } from "@angular/core";
import { ProfilePageSignalStore } from "../../types";

import {PROFILE_PAGE_SIGNAL_STORE} from '../signal-store';

export const PROFILE_PAGE_TOKEN = new InjectionToken<ProfilePageSignalStore>(
  'Profile Page',
);

export const PROFILE_PAGE_PROVIDER: Provider = {
  provide: PROFILE_PAGE_TOKEN,
  useClass: PROFILE_PAGE_SIGNAL_STORE,
};


export function profilePageTokenizer() {
  return inject(PROFILE_PAGE_TOKEN);
}